import { useState, useEffect } from "react";

export const OPS_COMPACT_QUERY = "(max-width: 1023.98px)";

/**
 * Single source of truth for the JS-side breakpoint; must agree exactly
 * with the CSS `1023.98px` TT-415 block in index.css.
 */
export function useIsCompact() {
  const [isCompact, setIsCompact] = useState(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return false;
    }
    return window.matchMedia(OPS_COMPACT_QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return undefined;
    }
    const mql = window.matchMedia(OPS_COMPACT_QUERY);
    setIsCompact(mql.matches);
    const onChange = (event) => setIsCompact(event.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isCompact;
}
